

export default umd;
import packageResult from 'utils/packageResult';
import umdIntro from 'utils/umd/umdIntro';
import requireName from 'utils/umd/requireName';
import transformBody from './utils/transformBody';
function umd(mod, options) {
	requireName(options);

	var intro = umdIntro({
		hasExports: mod.exports.length > 0,
		imports: mod.imports,
		amdName: options.amdName,
		absolutePaths: options.absolutePaths,
		name: options.name,
		indentStr: mod.body.getIndentString(),
		strict: true,
		useStrict: options.useStrict !== false
	});

	transformBody(mod, mod.body, {
		intro: intro,
		outro: '\n\n}));',
		_evilES3SafeReExports: options._evilES3SafeReExports
	});

	return packageResult(mod, mod.body, options, 'toUmd');
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/standalone/builders/strictMode/umd.js.01-babel.map